// @flow
import { Component } from 'react';

export type Props = {
  shouldScroll: boolean,
  errorClass: string,
};

export default class ScrollToError extends Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    return (
      this.props.shouldScroll !== nextProps.shouldScroll ||
      this.props.errorClass !== nextProps.errorClass
    );
  }

  componentDidUpdate() {
    const { shouldScroll, errorClass } = this.props;
    const errorElement = document.getElementsByClassName(errorClass)[0];
    if (shouldScroll && errorElement) {
      // $FlowFixMe
      errorElement.scrollIntoView({ block: 'nearest' });
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ../react-lib/src/components/utils/ScrollToError/ScrollToError.js